export var findRouteByPath = function (routes, path) {
    var route = routes.find(function (route) { return route.path === path; });
    if (route)
        return route;
    return routes.reduce(function (acc, route) { return (acc ? acc : findRouteByPath((route === null || route === void 0 ? void 0 : route.children) || [], path)); }, undefined);
};
